<template>
    <div class="container-user">
        <div class="wrap-title">
            <h4>Daftar User Admin</h4>
            <button type="button" class="btn btn-primary btn-sm" v-b-modal.modal-add-user>Tambah</button>
            <b-modal id="modal-add-user" ref="modal-add-user" title="Tambah User Admin">
                <form>
                    <div class="form-group">
                        <label for="" class="form-label">Nama Lengkap</label>
                        <div class="wrap-input">
                            <input type="text" placeholder="Masukkan Nama Lengkap" class="form-input" v-model="$v.form.fullname.$model" />
                            <div v-if="$v.form.fullname.$error" class="error">
                                <span v-if="!$v.form.fullname.required"> Nama Lengkap tidak boleh kosong</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Username</label>
                        <div class="wrap-input">
                            <input type="text" placeholder="Masukkan Username" class="form-input" v-model="$v.form.username.$model" />
                            <div v-if="$v.form.username.$error" class="error">
                                <span v-if="!$v.form.username.required"> Username tidak boleh kosong</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Email</label>
                        <div class="wrap-input">
                            <input type="text" placeholder="Masukkan email" class="form-input" v-model="$v.form.email.$model" />
                            <div v-if="$v.form.email.$error" class="error">
                                <span v-if="!$v.form.email.required"> Email tidak boleh kosong</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">No Telepon</label>
                        <div class="wrap-input">
                            <input type="text" placeholder="Masukkan no telelpon" class="form-input" v-model="$v.form.phonenumber.$model" />
                            <div v-if="$v.form.phonenumber.$error" class="error">
                                <span v-if="!$v.form.phonenumber.required"> No Telepon tidak boleh kosong</span>
                                <span v-else-if="!$v.form.phonenumber.minLength"> No Telepon minimal 10</span>
                                <span v-else-if="!$v.form.phonenumber.maxLength"> No Telepon minimal 13</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Password</label>
                        <div class="wrap-input">
                            <input :type="typeInput" placeholder="masukkan password" class="form-input" v-model="$v.form.password.$model" />
                            <div v-if="$v.form.password.$error" class="error">
                                <span v-if="!$v.form.password.required">Password tidak boleh kosong</span>
                                <span v-else-if="!$v.form.password.minLength">Password minimal 8 karakter</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group wrap-service" v-for="(service, indexForm) in form.service_access" :key="indexForm">
                        <div>
                            <label for="" class="form-label">Service</label>
                            <div class="wrap-input">
                                <select class="form-input" v-model="service.service" @change="chooseService(indexForm, $event)">
                                    <option value="" disabled selected>Pilih Service</option>
                                    <option v-for="(data, i) in accessData" :key="i" :value="data.service">{{ data.service }}</option>
                                </select>
                                <!-- <div class="error" v-if="$v.form.access.$error">
                  <span v-if="!$v.form.access.required">Akses tidak boleh kosong</span>
                </div> -->
                            </div>
                        </div>
                        <div>
                            <label for="" class="form-label">Akses</label>
                            <div>
                                <!-- <button type="button" class="btn btn-sm btn-access">Pilih Akses</button> -->
                                <div class="wrap-checkboxx">
                                    <div v-for="(access, indexAccess) in dataAccess[indexForm]" :key="indexAccess">
                                        <input type="checkbox" :id="indexAccess" :value="access" v-model="service.access" />
                                        <label :for="indexAccess">{{ access }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-service" @click="deleteService(indexForm, 'add')" v-show="indexForm != 0">
                            <b-icon icon="x" class="icon-plus"></b-icon>
                        </div>
                    </div>
                    <div class="add-service" @click="addService">
                        <b-icon icon="plus" class="icon-plus"></b-icon>
                        Tambahkan Servis Akses
                    </div>
                </form>
                <template #modal-footer>
                    <button type="button" class="btn-scondary">Keluar</button>
                    <button type="sybmit" class="btn-primer" @click="addUserAdmin">
                        <span v-if="!isLoading">Tambah</span>
                        <b-spinner variant="light" v-else></b-spinner>
                    </button>
                </template>
            </b-modal>
        </div>
        <div class="content">
            <div class="wrap-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Nama</th>
                            <th>Email</th>
                            <th>Username</th>
                            <th>Akses</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, i) in dataShow" :key="i">
                            <td>{{ i + 1 }}</td>
                            <td>{{ data.fullname }}</td>
                            <td>{{ data.email }}</td>
                            <td>{{ data.username }}</td>
                            <td style="width:13rem">
                                <div v-for="(dataService, j) in data.service_access" :key="j">
                                    {{ dataService.service }}
                                </div>
                            </td>
                            <td>
                                <span :class="data.status === 'active' ? 'statusActive' : 'statusBlock'">{{ data.status }}</span>
                            </td>
                            <td>
                                <div class="dropdown">
                                    <img src="@/assets/iconImage/kebab.png" alt="" class="kebab-icon" />
                                    <div class="dropdown-menus">
                                        <ul class="menu-dropdown">
                                            <li @click="sendData(data, 'password', 'modal-edit-user')">Ubah Password</li>
                                            <li @click="sendData(data, 'access', 'modal-edit-user')">Edit Akses</li>
                                            <li @click="sendData(data, 'access', 'modal-add-access')">Tambah Akses</li>
                                            <li @click="sendData(data, '', 'modal-confirmation')">
                                                <span :class="data.status === 'active' ? 'statusBlock' : 'statusActive'">
                                                    {{ data.status == "active" ? "Blok User" : "Aktiv User" }}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- <dropdown-directive>
                  <template v-slot:buttonDropdown> </template>
                  <template v-slot:menuDropdown>
                  </template>
                </dropdown-directive> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- modal edit user -->
        <b-modal ref="modal-edit-user" :title="'Edit User - ' + dataDetail.fullname">
            <form>
                <div class="form-group" v-if="typeEditModal == 'password'">
                    <label for="" class="form-label">Password</label>
                    <div class="wrap-input">
                        <input :type="typeInput" placeholder="masukkan password" class="form-input" v-model="$v.formEdit.password.$model" />
                        <div v-if="$v.formEdit.password.$error" class="error">
                            <span v-if="!$v.formEdit.password.required">Password tidak boleh kosong</span>
                            <span v-else-if="!$v.formEdit.password.minLength">Password minimal 8 karakter</span>
                        </div>
                    </div>
                </div>
                <div
                    class="form-group wrap-service"
                    v-for="(service, indexFormEdit) in formEdit.service_access"
                    :key="indexFormEdit"
                    v-show="typeEditModal == 'access'"
                >
                    <div>
                        <label for="" class="form-label">Service</label>
                        <div class="wrap-input">
                            <select class="form-input" v-model="service.service" @change="chooseService(indexFormEdit, $event)">
                                <option value="" disabled selected>Pilih Service</option>
                                <option v-for="(data, i) in accessData" :key="i" :value="data.service">{{ data.service }}</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <label for="" class="form-label">Akses</label>
                        <div class="wrap-access">
                            <dropdown-directive>
                                <template v-slot:buttonDropdown>
                                    <button type="button" class="btn btn-sm btn-access">
                                        Pilih Akses <span class="badge-access">{{ service.access.length }}</span>
                                    </button>
                                </template>
                                <template v-slot:menuDropdown>
                                    <div class="py-2 px-2">
                                        <div v-for="(access, indexAccess) in service.access" :key="indexAccess">
                                            <input type="checkbox" :id="indexAccess" :value="access" v-model="service.access" />
                                            <label :for="indexAccess" class="ml-2">{{ access }} </label>
                                        </div>
                                    </div>
                                </template>
                            </dropdown-directive>
                        </div>
                    </div>
                    <div class="add-service" @click="deleteExistingService(service)">
                        <b-icon icon="x" class="icon-plus"></b-icon>
                    </div>
                </div>
            </form>
            <template #modal-footer>
                <button type="button" class="btn-scondary" @click="hideModal('modal-edit-user')">Keluar</button>
                <button type="sybmit" class="btn-primer" @click="editUserAdmin" v-if="typeEditModal == 'password'">
                    <span v-if="!isLoading">Edit</span>
                    <b-spinner variant="light" v-else></b-spinner>
                </button>
            </template>
        </b-modal>
        <b-modal ref="modal-confirmation" :title="'Confirmation ' + dataDetail.fullname">
            <p class="text-center warning-content">
                Apakah anda yakin ingin Blok user <b>{{ dataDetail.fullname }}</b>
            </p>
            <template #modal-footer>
                <button type="button" class="btn-scondary" @click="hideModal('modal-confirmation')">Cancel</button>
                <button type="sybmit" class="btn-primer btn-sm" @click="handleOk">
                    <span v-if="!isLoading">Submit</span>
                    <b-spinner variant="light" v-else></b-spinner>
                </button>
            </template>
        </b-modal>
        <b-modal ref="modal-add-access" :title="'Tambah Akses' + dataDetail.fullname">
            <div class="form-group wrap-service">
                <div>
                    <label for="" class="form-label">Service</label>
                    <select name="" id="" v-model="formAddAccess.service" @change="chooseService(0, $event)" class="form-input">
                        <option value="" disabled selected>Pilih Service</option>
                        <option v-for="(data, i) in accessData" :key="i" :value="data.service">{{ data.service }}</option>
                    </select>
                </div>
                <div>
                    <label for="" class="form-label">Akses</label>
                    <div class="wrap-access">
                        <dropdown-directive>
                            <template v-slot:buttonDropdown>
                                <button type="button" class="btn btn-sm btn-access">Pilih Akses</button>
                            </template>
                            <template v-slot:menuDropdown>
                                <div class="p-2">
                                    <div v-for="(access, indexAccess) in dataAccess[0]" :key="indexAccess">
                                        <input type="checkbox" :id="access" :value="access" v-model="formAddAccess.access" />
                                        <label :for="access" class="ml-2">{{ access }}</label>
                                    </div>
                                </div>
                            </template>
                        </dropdown-directive>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <button type="button" class="btn-scondary" @click="hideModal('modal-add-access')">Cancel</button>
                <button type="sybmit" class="btn-primer btn-sm" @click="addAccessUser">
                    <span v-if="!isLoading">Submit</span>
                    <b-spinner variant="light" v-else></b-spinner>
                </button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import Axios from "axios";
import { required, minLength, maxLength, email } from "vuelidate/lib/validators";
import sha256 from "sha256";
import DropdownDirective from "../dropdown/DropdownDirective.vue";
export default {
    components: { DropdownDirective },
    data() {
        return {
            openDropdown: false,
            dataShow: [],
            totalData: [],
            isLoading: false,
            typeInput: "password",
            dataDetail: "",
            detailAkses: "",
            typeEditModal: "",
            accessData: [],
            dataAccess: [],
            form: {
                username: "",
                email: "",
                phonenumber: "",
                fullname: "",
                password: "",
                service_access: [{ service: "", access: [] }],
            },
            formEdit: {
                status: "",
                password: "",
            },
            formAddAccess: {
                service: "",
                access: [],
            },
        };
    },
    validations: {
        form: {
            username: {
                required,
            },
            email: {
                required,
                email,
            },
            phonenumber: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(13),
            },
            fullname: {
                required,
            },
            password: {
                required,
                minLength: minLength(8),
            },
        },
        formEdit: {
            status: {
                required,
            },
            password: {
                required,
                minLength: minLength(8),
            },
        },
    },
    mounted() {
        Axios.get("/v2/superadmin/user?limit=100&skip=0").then((res) => {
            this.dataShow = res.data.data.user;
        });
        Axios.get("/v2/superadmin/user/access").then((res) => {
            this.accessData = res.data.data;
        });

        console.log(this.formEdit.service_access);
    },

    methods: {
        handleOk() {
            this.isLoading = true;

            if (this.dataDetail.status == "active") {
                this.formEdit.status = "blocked";
            } else {
                this.formEdit.status = "active";
            }
            let data = {
                password: "",
                status: this.formEdit.status,
            };
            Axios.put("/v2/superadmin/user/" + this.dataDetail._id, data).then((res) => {
                this.isLoading = false;
                if (res.data.data.status_code == "00") {
                    let title = "Edit Status User " + this.dataDetail.fullname + " berhasi";
                    this.$toast.success(title);
                    setTimeout(function() {
                        location.reload();
                    }, 2000);
                }
            });
        },
        hideModal(modalRef) {
            this.$refs[modalRef].hide();
        },
        toogleDropdown() {
            this.openDropdown = !this.openDropdown;
        },
        addService() {
            let data = {
                service: "",
                access: [],
            };
            this.form.service_access.push(data);
        },
        addServiceEdit() {
            let data = {
                service: "",
                access: [],
            };
            this.formEdit.service_access.push(data);
        },
        deleteService(index, typeForm) {
            if (typeForm == "add") {
                this.form.service_access.splice(index, 1);
            } else {
                this.formEdit.service_access.splice(index, 1);
                Axios.delete("/v2/superadmin/user/access/user/" + this.dataDetail._id);
            }
            this.dataAccess.splice(index, 1);
        },
        deleteExistingService(service) {
            Axios.delete("/v2/superadmin/user/access/" + service.service + "/" + this.dataDetail._id).then((res) => {
                if (!res.data.iserror) {
                    this.$toast.success("Akses berhasil dihapus");
                    setTimeout(function() {
                        location.reload();
                    }, 2000);
                }
            });
        },
        chooseService(index, event) {
            let name = event.target.value;
            let data = this.accessData.find((t) => t.service == name);
            this.dataAccess[index] = data.access;
        },

        sendData(fullData, typeEdit, modalRef) {
            this.dataDetail = fullData;
            this.typeEditModal = typeEdit;
            this.$refs[modalRef].show();
            console.log(fullData);
            if (fullData) {
                this.formEdit.service_access = fullData.service_access;
            }
        },
        addUserAdmin() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            let data = {
                username: this.form.username,
                email: this.form.email,
                phonenumber: this.form.phonenumber,
                fullname: this.form.fullname,
                password: sha256(this.form.password),
                service_access: this.form.service_access,
            };
            this.isLoading = true;
            Axios.post("/v2/superadmin/user", data).then((res) => {
                this.isLoading = false;
                if (res.data.data.status_code == "00") {
                    this.$toast.success("User Admin berhasil ditambah");
                    setTimeout(function() {
                        location.reload();
                    }, 2000);
                }
            });
        },
        deleteUserAdmin(url) {
            this.isLoading = true;
            Axios.delete(url).then((res) => {
                if (res.data.data.status_code == "00") {
                    this.$toast.success("User berhasil dihapus");
                    setTimeout(function() {
                        location.reload();
                    }, 2000);
                    this.isLoading = false;
                }
            });
        },
        editUserAdmin() {
            this.isLoading = true;

            let data = {
                password: sha256(this.formEdit.password),
                status: this.formEdit.status,
            };
            Axios.put("/v2/superadmin/user/" + this.dataDetail._id, data).then((res) => {
                this.isLoading = false;
                if (res.data.data.status_code == "00") {
                    let title = "Edit data " + this.dataDetail.fullname + " berhasi";
                    this.$toast.success(title);
                    setTimeout(function() {
                        location.reload();
                    }, 2000);
                }
            });
        },
        addAccessUser() {
            this.isLoading = true;
            Axios.put("/v2/superadmin/user/access/" + this.dataDetail._id, this.formAddAccess).then((res) => {
                if (!res.data.iserror) {
                    this.$toast.success("Tambah Akses" + this.dataDetail.fullname + " Berhasil");
                    setTimeout(function() {
                        location.reload();
                    }, 2000);
                }
                this.isLoading = false;
            });
        },
        addAccessUserAdmin(url) {
            let paramUrl = url;
            // for (let i = 0; i < this.form.access.length; i++) {
            this.isLoading = true;
            Axios.patch(paramUrl)
                .then((res) => {
                    if (res.data.data.status_code == "00") {
                        this.isLoading = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.isLoading = false;
                });
            // }
        },
    },
};
</script>

<style scoped>
table {
    font-size: 14px;
}

td {
    word-wrap: break-word;
}

.form-group {
    margin-bottom: 1rem;
}

.form-label {
    width: 10rem;
}

.form-input,
.radio,
.wrap-checkbox {
    width: 100%;
}

.warning-content {
    font-size: 20px;
}

.wrap-service {
    display: flex;
    gap: 2rem;
}

.radio label {
    margin-bottom: unset;
}

.wrap-list-access {
    display: flex;
    flex-wrap: wrap;
}

.badge-access {
    color: #fff;
    background: #6454f0;
    border-radius: 50%;
    display: inline-block;
    width: 1rem;
    font-size: 11px;
    margin-left: 0.5rem;
}

.dropdown {
    position: relative;
}

.dropdown-menus {
    background: #ffffff;
    box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    text-align: left;
    position: absolute;
    right: 1rem;
    width: 10rem;
    z-index: 1;
    display: none;
}

.dropdown:hover .dropdown-menus {
    display: block;
}

.list-access {
    padding: 0.2rem;
    font-size: 13px;
    color: #6454f0;
}

.menu-dropdown {
    list-style: none;
    margin-bottom: unset;
}

.menu-dropdown li {
    cursor: pointer;
    line-height: 2;
    padding: 0.75rem;
}

.menu-dropdown li:hover {
    background: #eae7e7;
}

.kebab-icon {
    cursor: pointer;
}

.wrap-checkbox {
    /* display: flex;
  gap: 1rem;
  flex-wrap: wrap; */
    position: relative;
    background: #fff;
    padding: 0.75rem;
    box-shadow: 0 3px 6px rgb(50 50 93 / 19%), 0 1px 0 rgb(0 0 0 / 5%);
    margin-top: 0.75rem;
    pointer-events: none;
}

.active-menu {
    display: block;
}

.wrap-checkbox input {
    margin-right: 0.5rem;
}

.wrap-input {
    width: 100%;
}

.wrap-checkbox span input {
    margin-right: 0.5rem;
}

.error {
    padding: unset;
}

.add-service {
    display: flex;
    align-items: center;
    color: #6454f0;
    cursor: pointer;
    font-weight: 600;
}

.icon-plus {
    font-size: 1.5rem;
}

.wrap-access {
    position: relative;
}

.wrap-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
}

.statusActive {
    color: #28a745;
    font-weight: bold;
}
.statusBlock {
    color: #dc3545;
    font-weight: bold;
}

.access-list {
    padding: 0 0.5rem;
    border-radius: 1rem;
    border: solid 1px #6454f0;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 12px;
    background: transparent;
}

.access-list span {
    font-size: 15px;
}

.access-list span:hover {
    color: #dc3545;
}
</style>
